import gql from 'graphql-tag';

export const query = gql`
  query GameJoinability(
    $gameType: GameType!
    $gameId: Int!
    $gameIdAsID: ID
    $timeZone: String!
  ) {
    game(type: $gameType, id: $gameId) {
      id
      joinability(timeZone: $timeZone) {
        joinable
        code
      }
    }
    membershipOffer(type: $gameType, gameId: $gameIdAsID) {
      id
    }
  }
`;
